module.exports = __webpack_public_path__ + "media/images/product/e1-120731c6172708e2599af9a3f0c79bd9.png";